const routes = {
    ROOT: '/',
    EXPLORE: '/explore',
    RESULT: '/result',
    LOGIN: '/login',
    REGISTER: '/register',
    RESET: '/reset',
    CONFIRM_RESET: '/confirmReset',
    SIGNUP_SUCCESS: '/signupSuccess',
    APP: {
        ROOT: '/app/',
        DASHBOARD: '/app/dashboard',
        DRAW_POLYGON: '/app/draw',
        PROJECTS: {
            ROOT: '/app/projects',
            CREATE_PROJECT: '/app/projects/create',
            PROJECT: '/app/projects/:projectId'
        },
    },
    VISIT: {
        ROOT: '/visit/:projectId',
    }
};

export default routes;
